import { useEffect } from "react";
import { getConsent } from "./CookieConsent";

/**
 * Charge Meta Pixel + Google Analytics UNIQUEMENT si l'utilisateur a accepté les cookies.
 * IDs configurables via env :
 *   REACT_APP_META_PIXEL_ID=123456789012345
 *   REACT_APP_GA_ID=G-XXXXXXXXXX
 */
export default function AnalyticsLoader() {
  useEffect(() => {
    const load = () => {
      const c = getConsent();
      if (!c?.analytics) return;
      injectMetaPixel(process.env.REACT_APP_META_PIXEL_ID);
      injectGA(process.env.REACT_APP_GA_ID);
    };
    load();
    window.addEventListener("tpco-consent-changed", load);
    return () => window.removeEventListener("tpco-consent-changed", load);
  }, []);
  return null;
}

function injectMetaPixel(id) {
  if (!id || window.__tpcoMetaPixelLoaded) return;
  window.__tpcoMetaPixelLoaded = true;
  const s = document.createElement("script");
  s.innerHTML = `
    !function(f,b,e,v,n,t,s){if(f.fbq)return;n=f.fbq=function(){n.callMethod?
    n.callMethod.apply(n,arguments):n.queue.push(arguments)};if(!f._fbq)f._fbq=n;
    n.push=n;n.loaded=!0;n.version='2.0';n.queue=[];t=b.createElement(e);t.async=!0;
    t.src=v;s=b.getElementsByTagName(e)[0];s.parentNode.insertBefore(t,s)}(window,
    document,'script','https://connect.facebook.net/en_US/fbevents.js');
    fbq('init', '${id}');
    fbq('track', 'PageView');
  `;
  document.head.appendChild(s);
}

function injectGA(id) {
  if (!id || window.__tpcoGALoaded) return;
  window.__tpcoGALoaded = true;
  const s1 = document.createElement("script");
  s1.async = true;
  s1.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s1);
  const s2 = document.createElement("script");
  s2.innerHTML = `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());
    gtag('config', '${id}', { anonymize_ip: true });
  `;
  document.head.appendChild(s2);
}
